export const WRITE = "WRITE";
export const CLEAR = "CLEAR";
